export const getEnvVar = (key) => {
    // Check if we're running in Docker (env.js exists)
    if (window.ENV_VARIABLES && window.ENV_VARIABLES[key]) {
        return window.ENV_VARIABLES[key];
    }
    // Fallback to Vue's process.env for local development
    return process.env[key];
};